import axios from "./axios";

class LeadService {
  verifyAuthorization = async (token) => {
    try {
      const response = await axios.get(
        "/lead/websdk/verify_authorization?token=" + token,
        {}
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  create = async (
    authorization,
    name,
    pan_number,
    mobile,
    email,
    pincode,
    loan_amount
  ) => {
    try {
      const response = await axios.post("/lead/websdk/create", {
        authorization,
        name,
        pan_number,
        mobile,
        email,
        pincode,
        loan_amount,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new LeadService();
